<template>
  <span v-if="comprobante">
    <layout-comprobante-consultar :showArrowLeft="false">
      <template v-slot:title>
        Venta #{{ comprobante.numeroVentaPorArqueo }}
      </template>

      <template v-slot:navigation-controller>
        <v-list dark flat bg-color="transparent">
          <v-subheader
            class="text-uppercase font-weight-bold grey--text text-caption"
            >Información General</v-subheader
          >

          <v-list-item v-for="(item, i) in infoList" :key="i" class="px-0">
            <v-list-item-icon class="mr-4">
              <v-icon color="grey lighten-1">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle class="grey--text text-caption">{{
                item.label
              }}</v-list-item-subtitle>
              <v-list-item-title class="white--text font-weight-medium">{{
                item.value
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:button-navigation-controller>
        <div class="d-flex flex-column gap-2">
          <v-btn
            v-if="comprobante.origen"
            color="#4dabf7"
            depressed
            block
            large
            class="white--text font-weight-bold mb-3"
            @click="dialogFacturar = true"
          >
            Facturar <v-icon right>mdi-cloud-upload</v-icon>
          </v-btn>

          <template v-else>
            <v-btn
              outlined
              block
              large
              color="grey lighten-2"
              class="mb-3"
              @click="verFactura"
            >
              <v-icon left>mdi-file-document-outline</v-icon> Ver Factura
            </v-btn>
            <button-imprimir
              :id="comprobante.id"
              tipoComprobante="NV"
              block
              class="mb-3"
            />
          </template>

          <v-btn
            color="error"
            block
            text
            small
            class="mt-2"
            @click="dialogAnularComprobante = true"
            :disabled="!configuracion.puedeAnularComprobante"
          >
            Anular comprobante
          </v-btn>
        </div>
      </template>

      <template v-slot:vista-previa>
        <v-container fluid class="pa-6">
          <v-row>
            <v-col cols="12" lg="8">
              <div class="nexus-section-card">
                <lista-detalle-comprobante
                  :total="comprobante.total"
                  :descuento="comprobante.descuento"
                  :recargo="comprobante.recargo"
                  :motivoDescuento="comprobante.motivoDescuento"
                  v-if="detalles_comprobante.length > 0"
                  :detalles="detalles_comprobante"
                />
              </div>
            </v-col>

            <v-col cols="12" lg="4">
              <venta-cliente-vista-previa
                v-if="cliente"
                :formCliente="nombreEntidad"
                :formEnvio="nombreEntidadEnvio"
                :cliente="cliente"
              />
              <v-card
                v-else
                flat
                color="rgba(255,255,255,0.02)"
                class="pa-8 text-center border-nexus"
              >
                <v-icon size="64" color="rgba(255,255,255,0.1)"
                  >mdi-account-off</v-icon
                >
                <div class="grey--text mt-4">Cliente desconocido</div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </layout-comprobante-consultar>
    <v-dialog v-model="dialogAnularComprobante" persistent width="600">
      <v-card color="#242526">
        <v-container>
          <v-card-title>
            <b>
              <div style="font-size: 22px">¿Desea anular el comprobante?</div>
            </b>

            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon color="grey" @click="dialogAnularComprobante = false"
                >mdi-close</v-icon
              >
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="mt-2">
              <div style="font-size: 16px">Seleccione el motivo</div>
              <div class="text-center mt-2">
                <v-select
                  outlined
                  data-vv-name="motivo"
                  v-validate="'required'"
                  :error-messages="errors.collect('motivo')"
                  v-model="motivoAnulacion.descripcion"
                  :items="motivosAnulacion"
                  item-value="descripcion"
                  item-text="descripcion"
                  label="Motivo"
                >
                </v-select>
                <v-textarea
                  v-if="motivoAnulacion.descripcion == 'Otro'"
                  label="Comentarios"
                  outlined
                  data-vv-name="comentario"
                  v-validate="'max:100'"
                  :error-messages="errors.collect('comentario')"
                  rows="3"
                  counter="100"
                  style="font-size: 25px"
                  row-height="20"
                  v-model="motivoAnulacion.comentario"
                ></v-textarea>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="info" @click="dialogAnularComprobante = false" text>
              <b> Permanecer en la página </b>
            </v-btn>
            <v-btn
              :disabled="
                errors.any() || motivoAnulacion.descripcion == 'Otro'
                  ? motivoAnulacion.comentario
                    ? false
                    : true
                  : false
              "
              @click="validateForm"
              :loading="loadingAnular"
              color="info"
            >
              <b> Anular comprobante </b>
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import VentaClienteVistaPrevia from "@/components/venta/cliente/venta.cliente.vista-previa";
import ListaDetalleComprobante from "@/components/comprobante/detalle/comprobante.detalles.info.vue";
import InfoProveedor from "@/components/proveedor/proveedor.info";
import LayoutComprobanteConsultar from "@/layouts/layout.comprobante.consultar";
import DialogConfirmationClose from "@/components/dialogs/confirmation.close";
import FacturaPreImpresa from "@/components/venta/factura/venta.factura.pre-impreso.form.vue";

import FacturaPreImpresaConsultar from "@/components/venta/factura/venta.factura.pre-impreso.consultar.vue";

import VentasApi from "@/api/venta/venta";
import AfipFiscalAPI from "@/api/afipfiscal";
import ButtonImprimir from "@/components/tareas/buttonImprimir.vue";

import { mapState } from "vuex";

export default {
  name: "VentaDetalle",

  $_veeValidate: {
    validator: "new",
  },
  filters: {
    convertPesoArg(value) {
      return `$${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },
  components: {
    ListaDetalleComprobante,
    LayoutComprobanteConsultar,
    DialogConfirmationClose,
    InfoProveedor,
    VentaClienteVistaPrevia,
    FacturaPreImpresa,
    FacturaPreImpresaConsultar,
    ButtonImprimir,
  },
  data() {
    return {
      preImpreso: false,
      dialogConsultarPreImpreso: false,
      motivoAnulacion: {
        descripcion: "",
        comentario: "",
      },
      motivosAnulacion: [],
      dialogAnularComprobante: false,
      comprobante: null,
      detalles_comprobante: [],
      cliente: null,
      nombreEntidad: null,
      nombreEntidadEnvio: null,
      dialog: false,
      dialogFacturar: false,
      loadingFacturar: false,
      loadingAnular: false,
    };
  },
  computed: {
    ...mapState("sucursales", ["configuracion"]),
    fechaCreacion() {
      return this.moment(this.comprobante.fechaAlta).format("lll");
    },

    hay_detalles_para_ver() {
      if (this.detalles_comprobante.length > 0) {
        return true;
      }
      return false;
    },
    infoList() {
      return [
        {
          label: "Nro de comprobante",
          value: this.comprobante.nroComprobante,
          icon: "mdi-text-box-outline",
        },
        {
          label: "Fecha de venta",
          value: this.fechaCreacion,
          icon: "mdi-calendar-range",
        },
        {
          label: "Forma de pago",
          value: this.comprobante.formasDePago.map((f) => f.nombre).join(", "),
          icon: "mdi-cash",
        },
        {
          label: "Vendedor",
          value: this.comprobante.get_user,
          icon: "mdi-account-tie",
        },
        {
          label: "Tipo",
          value: `${this.comprobante.letra} ${
            this.comprobante.es_preimpreso ? "- Pre-impreso" : ""
          }`,
          icon: "mdi-file-certificate",
        },
      ];
    },
  },
  methods: {
    async getMotivosAnulacion() {
      try {
        const response = await this.axios.get("comprobantes/motivosanulacion");
        this.motivosAnulacion = response.data;
      } catch (error) {}
    },
    async registrarFacturaElectronica() {
      this.loadingFacturar = true;
      try {
        await VentasApi.facturar(this.comprobante.id);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: `Comprobante facturado`,
          icon: "mdi-check",
          timeout: 3000,
        });
        this.dialogFacturar = false;

        this.$router.push("/ventas");
      } catch (error) {
        console.log(error);
        this.loadingFacturar = false;
        var message = error.response.data.detail
          ? error.response.data.detail
          : `Hubo un problema en la facturación`;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "red",
          text: message,
          icon: "mdi-information",
          timeout: 3000,
        });
      }
    },
    verFactura() {
      if (this.comprobante.es_preimpreso) {
        this.dialogConsultarPreImpreso = true;
      } else {
        AfipFiscalAPI.show(this.comprobante.id)
          .then((response) => {
            window.open(response.data.pdf_url, "_blank");
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    validateForm() {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.anularComprobante();
        } else {
          this.$validator.validate();
        }
      });
    },
    async anularComprobante() {
      this.loadingAnular = true;

      var id = this.$route.params.id;
      try {
        const response = await VentasApi.anular(id, this.motivoAnulacion);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: `Venta anulada`,
          icon: "mdi-check",
          timeout: 3000,
        });
        this.dialogAnularComprobante = false;
        this.loadingAnular = false;

        this.$router.push("/ventas");
      } catch (error) {
        this.loadingAnular = false;
        var message = error.response.data.detail
          ? error.response.data.detail
          : `No se pudo anular la venta.`;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "red",
          text: message,
          icon: "mdi-information",
          timeout: 3000,
        });
      }
    },
    async fetchComprobante(id) {
      var response = await VentasApi.show(id);
      this.comprobante = response.data;

      this.detalles_comprobante = this.comprobante.detalles_comprobante;
      this.cliente = this.comprobante.cliente;
      this.nombreEntidad = this.comprobante.nombreEntidad;

      this.nombreEntidadEnvio = this.comprobante.nombreEntidad.envio;
    },
  },

  created() {
    this.$store.commit("SET_LAYOUT", { layout: "layout-basic", withNav: true });

    let id = this.$route.params.id;

    this.fetchComprobante(id);
    this.getMotivosAnulacion();
  },
};
</script>

<style scoped>
gap-2 {
  gap: 12px;
}
.nexus-section-card {
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.border-nexus {
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
